import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import Logo from "../../assets/img/logo.webp";
import "animate.css";
import { useNav } from "../../context/nav-context";
import { Link } from "react-router-dom";
const Navbar = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Trigger animations each time the element comes into view
    threshold: 0.2, // Trigger when 20% of the component is visible
  });

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const { activeLink } = useNav();

  return (
    <>
      <nav
        ref={ref}
        className={`navbar navbar-expand-lg fixed-top navbar-light bg-white  ${
          scrolled ? "" : ""
        }`}
      >
        <div className="container">
          <div className="d-flex justify-content-between align-items-center w-100 gap-3">
            <Link href="/">
              <img
                src={Logo}
                alt="Logo"
                className={`img-fluid ${
                  inView
                    ? "animate__animated animate__slideInLeft"
                    : "animate__animated animate__slideInRight"
                }`}
                width="150"
              />
            </Link>

            <ul
              className={`navbar-nav d-none d-lg-flex justify-content-center fs-16 w-100 gap-4 ${
                inView
                  ? "animate__animated animate__slideInDown"
                  : "animate__animated animate__slideInUp"
              }`}
            >
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "home" ? "active" : ""
                  }`}
                  to={"/#home"}
                  // to={{
                  //   pathname:"/",
                  //   hash : "#home"
                  // }}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "whyus" ? "active" : ""
                  }`}
                  to={"/#WhyUs"}
                >
                  Why Choose Us?
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "aligners" ? "active" : ""
                  }`}
                  to={"/#aligners"}
                >
                  Aligners
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "transformations" ? "active" : ""
                  }`}
                  to={"/#transformations"}
                >
                  Transformations
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "fixes" ? "active" : ""
                  }`}
                  to={"/#fixes"}
                >
                  What Can Alignar Fix
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    activeLink === "journey" ? "active" : ""
                  }`}
                  to={"/#journey"}
                >
                  Your Journey
                </Link>
              </li>
            </ul>

            <Link
              href="#contact"
              className={`text-center text-decoration-none btn-outline-theme-contact d-none d-lg-block ${
                inView
                  ? "animate__animated animate__slideInRight"
                  : "animate__animated animate__slideInLeft"
              }`}
              style={{ fontSize: "16px" }}
              onClick={() => {
                const section = document.getElementById("contact");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              Book Free Consultation
            </Link>

            <button
              className="navbar-toggler d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </div>
      </nav>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
            Menu
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav flex-column gap-3">
            <li className="nav-item">
              <Link
                className={`nav-link ${activeLink === "home" ? "active" : ""}`}
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                href="/"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                href="#WhyUs"
              >
                Why Choose Us?
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                href="#aligners"
              >
                Aligners
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                href="#journey"
              >
                Your Journey
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                href="#transformations"
              >
                Transformations
              </a>
            </li>
            <li className="nav-item mt-4">
              <a
                href="#contact"
                className="btn border border-dark rounded-5 py-1 px-4 d-none d-lg-block fs-16"
                onClick={() => {
                  // Get the close button element
                  const closeButton = document.querySelector(
                    "#offcanvasNavbar .btn-close"
                  );
                  if (closeButton) {
                    // Simulate a click on the close button
                    closeButton.click();
                  }
                }}
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                Get in Touch
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
